import { render, staticRenderFns } from "./OnboardingView.vue?vue&type=template&id=66145b60&lang=pug"
import script from "./OnboardingView.vue?vue&type=script&lang=ts"
export * from "./OnboardingView.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingView.vue?vue&type=style&index=0&id=66145b60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
